var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('o2o-errand-head',{attrs:{"flag":true}}),_c('div',[_c('index-header'),(_vm.navs && _vm.navs.length > 0)?_c('index-menu',{attrs:{"items":_vm.navs}}):_vm._e(),_c('common-store-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }